<template>
  <div>
    <div class="fixed top-0 left-0 w-screen h-screen z-50 p-0 filter" />
    <button
      class="
      block bg-black/50 
      border-none border-0 outline-none
      w-screen h-screen
      cursor-default
      fixed top-0 left-0
      z-50 p-0"
      role="button"
      :name="props.a11yName"
      :aria-label="props.a11yName"
      @click.prevent="emits('close')"
      @keydown.enter.stop.prevent="emits('close')"
    >
      <Transition name="slide-fade" appear @click.stop @keydown.enter.stop>
        <div
          class="bg-background w-full rounded-t-lg box-border fixed bottom-0 z-10 px-4 overflow-hidden blur-none"
          :class="[...props.customClass]"
          @click.stop @keydown.enter.stop.prevent @keydown.space.stop.prevent
        >
          <div class="max-w-appMaxWidth in-car:max-w-appMaxWidthLandscape mx-auto relative" :class="[...props.customClass]">
            <div v-if="props.title" class="py-10 rp-fs-15-ln text-left pb-6">
              <RydIcon v-if="props.icon" :icon="props.icon" class="mb-4 h-11 w-11" />
              <div>
                <p class="font-bold pb-2">
                  {{ props.title }}
                </p>
                <p v-if="props.description">
                  {{ props.description }}
                </p>
              </div>
            </div>
            <slot></slot>
          </div>
        </div>
      </Transition>
    </button>
  </div>
</template>
<script setup lang="ts">
import { onBeforeMount, onMounted, onUnmounted } from 'vue';
import RydIcon from '@/components/RydIcon/RydIcon.vue';
onMounted(() => document.body.style.overflow = 'hidden');
onBeforeMount(() => document.body.style.overflow = 'auto');
onUnmounted(() => document.body.style.overflow = 'auto');
const props = defineProps({
  customClass: {
    type: Array,
    default: (): Array<any> => []
  },
  a11yName: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
  icon: {
    type: String,
    default: ''
  }
});
const emits = defineEmits(['close'])

</script>
<style lang="scss" scoped>
  .filter {
    backdrop-filter: blur(2px);
  }
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all 0.3s ease-out;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(80px);
  opacity: 0;
}
</style>

